<div class="text-center" *ngIf="!error">
    <h3>
      Please wait we are processing your strava connection... 
    </h3>
    <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
</div>

<div class="text-center" *ngIf="error">
    <h3>
      An error occured, please try again later or contact support.
    </h3>
</div>

